export const SUBMIT_FORM = "SUBMIT_FORM";
export const SUBMIT_FORM_SUCCESS = "SUBMIT_FORM_SUCCESS";
export const SUBMIT_FORM_FAIL = "SUBMIT_FORM_FAIL";

export const FETCH_FORM = "FETCH_FORM";
export const FETCH_FORM_SUCCESS = "FETCH_FORM_SUCCESS";
export const FETCH_FORM_FAIL = "FETCH_FORM_FAIL";
